import { useState, useCallback } from 'react';

/**
 * Custom hook for managing selection state
 * Extracted from ExperimentBoard for reusability
 */
export const useSelection = () => {
  const [selectedIds, setSelectedIds] = useState(new Set());
  
  const toggleSelection = useCallback((id) => {
    setSelectedIds(prev => {
      const isCurrentlySelected = prev.has(id);
      
      // Create new Set only if state actually changes
      if (isCurrentlySelected) {
        if (prev.size === 1) {
          // Last item - return empty Set reference for better performance
          return new Set();
        }
        const next = new Set(prev);
        next.delete(id);
        return next;
      } else {
        const next = new Set(prev);
        next.add(id);
        return next;
      }
    });
  }, []); // No dependencies - pure function
  
  const clearSelection = useCallback(() => {
    setSelectedIds(new Set());
  }, []);
  
  const isSelected = useCallback((id) => {
    return selectedIds.has(id);
  }, [selectedIds]);
  
  const selectAll = useCallback((ids) => {
    setSelectedIds(new Set(ids));
  }, []);
  
  const deselectAll = useCallback(() => {
    clearSelection();
  }, [clearSelection]);
  
  return {
    selectedIds,
    selectedCount: selectedIds.size,
    isMultiSelect: selectedIds.size > 1,
    toggleSelection,
    clearSelection,
    isSelected,
    selectAll,
    deselectAll
  };
};

export default useSelection;